import './index.scss'
import { Link } from "react-router-dom"
import { useContext } from "react"
import { MenuContext } from "../../../app"
import {motion} from "framer-motion"
import {ReactComponent as Global} from "../../../assets/logos/global-edit.svg"


const MobileNav = () => {

    const props = useContext(MenuContext);
    const {isOpen, setIsOpen, setIsOn, isOn} = props

    const toggleSwitch = () => setIsOn(!isOn);

    const spring = {
        type: "spring",
        stiffness: 700,
        damping: 30
    };

    return(
        <>
        <motion.div initial={{x:"-100vw"}} animate={{x:isOpen?0:"-100vw"}} transition={{duration:0.5,type:"tween"}} className="bg-col-white d-flex flex-column align-items-center rounded-15 popup position-absolute z-index-4 top-35 right-0">
            <div className="marquee-container"><p className="marquee-text text-10 col-secondary">"Chennai Roots, Silicon Valley Vision: Welcome to Walkzero's Next Gen HRMS." #IndiaSaas #SaasBoomi</p></div>
            <Link to="" className="link menu-item-box" onClick={() => setIsOpen(false)}><span>Product</span></Link>
            <Link to="" className="link menu-item-box" onClick={() => setIsOpen(false)}><span>Pricing</span></Link>
            <Link to="/about-us" className="link menu-item-box" onClick={() => setIsOpen(false)}><span>About us</span></Link>
            <Link to="" className="link menu-item-box" onClick={() => setIsOpen(false)}><span>Blogs</span></Link>
            <Link to="" className="link menu-item-box" onClick={() => setIsOpen(false)}><span>Login</span></Link>
            <div className="d-flex flex-row justify-content-center align-items-center mt-4 mb-4"> 
                <div className="d-flex align-items-center">
                    <span className="text-10 col-black-800">High Contrast</span>
                    <div className="ms-1 switch" data-ison={isOn} onClick={toggleSwitch}>
                        <motion.div className="handle" layout transition={spring} />
                    </div>
                </div>
                <div className="d-flex align-items-center m-l-30">
                    <span className="text-10 col-black-800 me-1">English</span>
                    <Global width={15} height={15}/>
                </div>
            </div>
            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                <Link to='/book-a-demo' className="demo w-45" onClick={() => setIsOpen(false)}>
                    <button className="col-secondary rounded-10 font-bold text-14 font-weight-700 book-demo-btn w-100 p-y-10 btn-6">Book a Demo</button>
                </Link>
                <Link to="/sign-up" className="demo w-45" onClick={() => setIsOpen(false)}>
                <button className="get-started-btn text-12 btn-5 w-100 h-px-40" type="button">Get Started</button>
                </Link>
            </div>
        </motion.div>
        </>
    )
}

export default MobileNav